import { grey } from "@mui/material/colors";
import { DataGrid } from "@mui/x-data-grid";
import { arrType, converAttrToDatagridCol, datatypes, inputTypes, selectOptionsKeyName } from "data/globalData";
import { totalSizeRatioColumn } from "../../data";
import { convertSizeStringToStandardInputFormat, orderQtyStaticColumns } from "../data";

import { Box, Typography, Stack, Button, Tooltip } from "@mui/material";
import DisplayTable from "components/ReusableComponents/DisplayTable";
import { GlobalState } from "context/GlobalContext";
import { ContentPasteRounded } from "@mui/icons-material";

const SizeAllChannelCutQtyRatio = ({
	hideContent = false,
	tableColumns = [],
	channel,
	tableRows,
	channelSizeRows = [],
	handleDataChange,
	allChannels,
	allSizes,
	editMode = false,
	manualMode = false,
	handleBulkPaste,
}) => {
	const { snackBar, setSnackBar, setSnackBarOpen } = GlobalState();
	const tableRowsState = tableRows.map((row) => {
		const total = channelSizeRows
			.filter((csRow) => csRow.size === row.size)
			.reduce((acc, row) => {
				return +acc + +row.size_qty;
			}, 0);
		return {
			...row,
			order_qty: total,
		};
	});

	const handleRowDataChange = (newRow, oldRow) => {
		return handleDataChange(newRow, oldRow, channel);
	};

	const handlePaste = async () => {
		const text = await navigator.clipboard.readText();
		const pastedRows = [];
		text.trim().split("\n").forEach((line) => {
			const cols = line.split("\t");
			const size = cols[0]?.trim();
			const cut_qty = parseFloat(cols[1]);
			if (!size || !isFinite(cut_qty)) return;
			const existingRow = tableRowsState.find((r) => r.size === size);
			if (!existingRow) return;
			pastedRows.push({ size, cut_qty });
		});
		const matched = pastedRows.length;
		setSnackBarOpen(true);
		if (matched === 0) {
			setSnackBar({ ...snackBar, message: "No matching size names found in clipboard", severity: "error", anchorOrigin: { horizontal: "center", vertical: "top" } });
			return;
		}
		handleBulkPaste(pastedRows);
		setSnackBar({ ...snackBar, message: `Pasted successfully (${matched} rows updated)`, severity: "success", anchorOrigin: { horizontal: "center", vertical: "top" } });
	};

	const cutQtyRatioTableColumns = [
		{
			name: "Size",
			key: "size",
			data_type: datatypes.STRING.key,
			input_type: inputTypes.SELECT.key,
			default_value: allChannels?.[0],
			[selectOptionsKeyName]: { type: arrType, list: allChannels.map((ch) => ({ name: ch, key: ch })) },
		},
		{
			name: "Order Quantity",
			key: "order_qty",
			data_type: datatypes.NUMBER.key,
			input_type: inputTypes.ENTER.key,
			default_value: 0,
		},
		{
			name: "Cut Qty",
			key: "cut_qty",
			data_type: datatypes.NUMBER.key,
			input_type: inputTypes.ENTER.key,
			default_value: 0,
			editable: true,
		},

		{
			name: "Cut Qty %",
			key: "cut_qty_percent",
			data_type: datatypes.DECIMAL.key,
			input_type: inputTypes.ENTER.key,
			default_value: 0,
		},
	];

	return (
		<Stack width="100%" spacing={2}>
			<Box visibility={hideContent ? "hidden" : "visible"}>
				<Box display="flex" alignItems="center" gap={1} mb={0.5}>
					<Typography variant="h6">
						Size Cut Qty Ratio {manualMode ? <span style={{ color: "red" }}>(Manual Mode)</span> : ""}
					</Typography>
					{editMode && (
						<Tooltip title="Paste from Excel">
							<Button size="small" variant="outlined" startIcon={<ContentPasteRounded fontSize="small" />} onClick={handlePaste}>Paste</Button>
						</Tooltip>
					)}
				</Box>
				<DataGrid
					rows={tableRowsState ? tableRowsState : []}
					getRowId={(row) => row.id}
					columns={cutQtyRatioTableColumns.map((col) => converAttrToDatagridCol(col))}
					sx={{
						width: "100%",
						// maxHeight: 250,
						"& .MuiDataGrid-row": {
							cursor: "pointer",
						},
						"& .MuiDataGrid-row:hover": {
							backgroundColor: "transparent",
						},
						"& .MuiDataGrid-columnHeader": {
							cursor: "pointer",
							background: grey[400],
							textTransform: "uppercase",
						},
						"& .MuiDataGrid-cell": {
							padding: 0,
						},
					}}
					density="compact"
					disableRowSelectionOnClick
					pagination={false} // Remove footer
					hideFooter={true}
					showCellVerticalBorder
					showColumnVerticalBorder
					isCellEditable={({ row }) => editMode}
					processRowUpdate={handleRowDataChange}
					autoHeight
				/>
			</Box>
		</Stack>
	);
};

export default SizeAllChannelCutQtyRatio;
